import {Graphics, Point} from 'pixi.js';
import {IPoint} from '../../../interfaces/primitives/IPoint';
import {IRectangle} from '../../../interfaces/primitives/IRectangle';

export class SelectorRectangle extends Graphics
{
    private _scale = 1;
    private startPoint: Point = new Point();

    end(): void {
        this.visible = false;
    }

    setScale(scale: number): void {
        this._scale = scale;
    }

    startAt(startPoint: Point): void {
        this.clear();
        this.visible = true;
        this.startPoint.set(startPoint.x, startPoint.y);
    }

    drawTo(point: IPoint): IRectangle {
        let startX: number = this.startPoint.x / this._scale;
        let startY: number = this.startPoint.y / this._scale;
        let endX: number = point.x / this._scale;
        let endY: number = point.y / this._scale;
        let width: number = Math.abs(endX - startX);
        let height: number = Math.abs(endY - startY);
        let totalStartX: number = Math.min(startX, endX);
        let totalStartY: number = Math.min(startY, endY);
        this.clear();
        this.lineStyle(1, 0xffffff, .9);
        this.beginFill(0xffffff, .3);
        this.drawRect(totalStartX, totalStartY, width, height);
        this.endFill();
        return {x: totalStartX, y: totalStartY, width, height};
    }
}
